import { render, staticRenderFns } from "./TicketsChatMessage.vue?vue&type=template&id=16c41cf5&"
import script from "./TicketsChatMessage.vue?vue&type=script&lang=js&"
export * from "./TicketsChatMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports